import { defineStore } from 'pinia'
import { MessageAPI } from '@/services/message'
import { ref } from 'vue'
export const useBackgroundStore = defineStore('background', () => {
  const backgroundList = ref<any[]>([])
  const getBackgroundList = async (roleId: number) => {
    const res = await MessageAPI.roleAlbum({
      roleId: roleId
    })
    backgroundList.value = res.data
  }
  return {
    backgroundList,
    getBackgroundList
  }
})
